/* unplugin-vue-components disabled */import script from "./DepositMoneyList.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositMoneyList.vue?vue&type=script&setup=true&lang=js"

import "./DepositMoneyList.vue?vue&type=style&index=0&id=5e5656ce&lang=scss"

const __exports__ = script;

export default __exports__